/* eslint-disable */
import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
} from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import axios from 'axios';
import { getStorage } from '../../utils/functions/localstorage';

const FinalConfirmationPopup = ({ open, onClose }) => (
  <Dialog
    open={open}
    onClose={onClose}
    PaperProps={{
      sx: {
        borderRadius: '15px',
        width: '400px',
      },
    }}
  >
    <DialogContent>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: 'bold',
          fontSize: '24px',
          marginTop: '20px',
        }}
      >
        <CheckCircleOutlineIcon
          sx={{ fontSize: 90, color: 'green', marginBottom: '10px' }}
        />
        บันทึกสำเร็จ !
      </Box>
    </DialogContent>
    <DialogActions sx={{ display: 'flex', justifyContent: 'center' }}>
      <Box
        sx={{
          width: '25%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          border: '1px solid',
          borderRadius: '9px',
          color: '#45A6F5',
          backgroundColor: 'transparent',
          '&:hover': {
            backgroundColor: '#E3F3FF',
          },
          margin: 'auto',
        }}
      >
        <Button onClick={onClose}>Close</Button>
      </Box>
    </DialogActions>
  </Dialog>
);

const DeleteAccountManagementSuperAdmin = ({ open, onClose, deleteId }) => {
  const [showConfirmation, setShowConfirmation] = useState(false);

  const handleDelete = async () => {
    try {
      const { data: responseData } = await axios.post(
        `${process.env.REACT_APP_APIHOST}/del_admin`,
        {
          id: deleteId.id,
        },
        {
          headers: { Authorization: getStorage('token') },
        },
      );
      if (responseData === 'delete success') {
        setShowConfirmation(true);
      } else {
        alert('An error occurred while deleting the data.');
      }
    } catch (error) {
      console.log(error.message);
      alert('An error occurred while deleting the data.');
    }
  };

  const handleCloseConfirmation = () => {
    setShowConfirmation(false);
    window.location.reload();
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        PaperProps={{
          sx: {
            borderRadius: '15px',
            width: '100%',
            maxWidth: '430px',
          },
        }}
      >
        <DialogTitle>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              fontWeight: 'bold',
              fontSize: '20px',
              marginTop: '20px',
            }}
          >
            ลบบัญชีผู้ใช้
          </Box>
        </DialogTitle>
        <DialogContent
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            fontSize: '17px',
            marginTop: '18px',
          }}
        >
          คุณแน่ใจหรือไม่ว่าต้องการลบบัญชีผู้ใช้
        </DialogContent>
        <DialogActions
          sx={{
            display: 'flex',
            justifyContent: 'center',
            marginTop: '18px',
            marginBottom: '20px',
          }}
        >
          <Button
            onClick={onClose}
            sx={{
              width: '100px',
              border: '1px solid',
              color: '#FC3A3A',
              backgroundColor: 'transparent',
              '&:hover': {
                backgroundColor: 'rgba(252, 58, 58, 0.1)',
              },
            }}
          >
            ยกเลิก
          </Button>
          <Button
            onClick={handleDelete}
            sx={{
              width: '100px',
              border: '1px solid ',
              color: '#51D245',
              backgroundColor: 'transparent',
              '&:hover': {
                backgroundColor: 'rgba(81, 210, 69, 0.1)',
              },
            }}
          >
            ยืนยัน
          </Button>
        </DialogActions>
      </Dialog>
      <FinalConfirmationPopup
        open={showConfirmation}
        onClose={handleCloseConfirmation}
      />
    </>
  );
};

export default DeleteAccountManagementSuperAdmin;
